'use strict';

const handleGoogleClaimLocationsSocket = (window, listingsManagerUrl, site, pmtElmService) => {
	const io = window.io;
	function socketInit() {
		const baseUrl = listingsManagerUrl
			.replace('https', 'wss')
			.replace('http', 'ws')
			.replace('/listings/', '/');
		const socketUrl = baseUrl + 'info';

		return io.connect(socketUrl, {
			query: 'site=' + site,
			transports: ['websocket'],
			path: '/listings/socket.io'
		});
	}
	const socket = socketInit();
	socket.on('googleLocationFinder', msg => {
		pmtElmService.sendData(
			'Tasks.Google.Claim.Main',
			`in_Tasks_Google_Claim_Main_locationFinderEvent`,
			msg.msg
		);
	});
	socket.on('googleClaimLocations', msg => {
		pmtElmService.sendData(
			'Tasks.Google.Claim.Main',
			`in_Tasks_Google_Claim_Main_networkStatus`,
			msg.msg
		);
	});
};

module.exports = { handleGoogleClaimLocationsSocket };
